import { IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';

interface ClearFieldButtonProps {
    onClick: () => void;
    onMouseDown: (e: React.MouseEvent<HTMLButtonElement>) => void;
    ariaLabel: string;
}

export const ClearFieldButton: React.FC<ClearFieldButtonProps> = ({ onClick, onMouseDown, ariaLabel }) => (
    <IconButton onClick={onClick} onMouseDown={onMouseDown} size="small" tabIndex={-1} aria-label={ariaLabel}>
        <Close />
    </IconButton>
);
